export const ADDRESS_ERROR_MESSAGES = {
  INVALID_ADDRESS: "Please enter a valid address",
  US_ONLY:
    "We currently only support addresses in the United States. Please enter a valid US address.",
  UPDATE_FAILED: "Unable to update your address at this time. Please try again.",
  UNEXPECTED_ERROR: "Unexpected error occurred while saving address",
} as const;

export const SUPPORTED_COUNTRY_CODES = ["US"] as const;
